import React from 'react'
import { Box, Text } from '@workwhile/ui'
import { Header } from 'components/Header'
import { AssessmentsQueueFilters } from './AssessmentsQueueFilters'
import { PendingEvaluationsTable } from './PendingEvaluationsTable'
import { useAssessmentsQueueContextValue } from '../context/AssessmentsQueueProvider'

export const AssessmentsQueueMain = () => {
  const {
    state: { upcoming, past },
    actions: { loadMoreUpcoming, loadMorePast },
  } = useAssessmentsQueueContextValue()

  const sections = [
    {
      title: 'Upcoming shifts',
      table: upcoming,
      onLoadMore: loadMoreUpcoming,
    },
    {
      title: 'Past shifts',
      table: past,
      onLoadMore: loadMorePast,
    },
  ] as const

  return (
    <>
      <Header title="Assessments Queue" />
      <Box px={3} pb={4}>
        <AssessmentsQueueFilters />
        {sections.map(({ title, table, onLoadMore }, index) => (
          <Box key={title} mb={index < sections.length - 1 ? 4 : undefined}>
            <Text fontWeight="bold" mb={2}>
              {title}
            </Text>
            <PendingEvaluationsTable table={table} onLoadMore={onLoadMore} />
          </Box>
        ))}
      </Box>
    </>
  )
}
